import React, { useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { BRANDS } from "../utils/data";
import { useI18n } from "../contexts/I18nContext";

export default function BrandSelector({ value, onChange }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  React.useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const getLabel = (b) => {
    if (b === "All") return t("brandSelector.allBrands");
    if (b === "My Collection") return t("brandSelector.myCollection");
    return b;
  };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-1.5 px-3 py-2 rounded-xl text-xs font-medium cursor-pointer bg-white/80 backdrop-blur-sm border border-slate-200 text-slate-600 hover:bg-slate-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-rose-pastel-300"
        aria-label={t("brandSelector.aria")}
      >
        <span className="truncate">{getLabel(value)}</span>
        <ChevronDown
          size={13}
          className={`flex-shrink-0 text-slate-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="absolute left-0 right-0 mt-2 bg-white/95 backdrop-blur-md rounded-xl shadow-soft-xl border border-slate-100 py-2 z-50 animate-fadeIn max-h-60 overflow-y-auto">
          {BRANDS.map((b) => (
            <button
              key={b}
              type="button"
              onClick={() => { onChange(b); setOpen(false); }}
              className={`w-full px-4 py-1.5 text-left text-xs flex items-center justify-between hover:bg-slate-50 transition-colors ${
                value === b ? "text-rose-pastel-600 font-semibold" : "text-slate-700"
              }`}
            >
              <span className="truncate">{getLabel(b)}</span>
              {value === b && <Check size={12} className="text-rose-pastel-500 flex-shrink-0 ml-2" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
